"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./index.scss");
const useAmpli_1 = require("hooks/useAmpli");
const React = __importStar(require("react"));
const layouts_1 = require("../../shared/layouts");
const useInvitation_1 = require("../useInvitation");
const ActionButtons_1 = __importDefault(require("./ActionButtons"));
const ErrorMessage_1 = __importDefault(require("./ErrorMessage"));
const HeaderSection_1 = __importDefault(require("./HeaderSection"));
const LoadingState_1 = __importDefault(require("./LoadingState"));
const PlanSelection_1 = __importDefault(require("./PlanSelection"));
const SubscriptionBenefits_1 = __importDefault(require("./SubscriptionBenefits"));
const TsPlusOfferNew = () => {
    const [selectedPlan, setSelectedPlan] = React.useState('yearly');
    const { offers, continueInviteClassic, isProcessing, invitationLoading, invitationLoadError, loadOffers, loadOffersError, checkout, checkoutError, } = React.useContext(useInvitation_1.InvitationContext);
    const { screenViewed, onboardingButtonClicked } = (0, useAmpli_1.useAmpli)();
    const PLANS = [
        {
            id: offers?.annual?.id ?? '',
            type: 'yearly',
            price: `$${(offers?.annual?.priceInCents ?? 0) / 100} / yearly`,
            trial: offers?.annual?.trialLengthInDays ? `${offers?.annual?.trialLengthInDays} days free` : '',
            badgeLabel: offers?.annual?.saveDescription,
        },
        {
            id: offers?.monthly?.id ?? '',
            type: 'monthly',
            price: `$${(offers?.monthly?.priceInCents ?? 0) / 100} / monthly`,
            trial: offers?.monthly?.trialLengthInDays ? `${offers?.monthly?.trialLengthInDays} days free` : '',
        },
    ];
    const isTrialEligible = !!offers?.monthly?.trialLengthInDays;
    const SUBSCRIPTION_BENEFITS = [
        'Ad-free experience',
        'Age and skill-based practice plans',
        'Easy to browse practice drills',
        '1-on-1 drills to train at home',
    ];
    const onDecline = () => {
        onboardingButtonClicked('Skip TS+', useAmpli_1.AmplitudeScreenNames.TS_PLUS_OFFER);
        continueInviteClassic();
    };
    const onCheckout = async () => {
        const priceId = PLANS.find((p) => p.type === selectedPlan)?.id;
        onboardingButtonClicked('Start TS+', useAmpli_1.AmplitudeScreenNames.TS_PLUS_OFFER_2025);
        await checkout(priceId ?? '');
    };
    const error = invitationLoadError || loadOffersError || checkoutError;
    React.useEffect(() => {
        if (!invitationLoading && !offers) {
            loadOffers().then((data) => {
                if (!data) {
                    continueInviteClassic();
                }
                else {
                    screenViewed(useAmpli_1.AmplitudeScreenNames.TS_PLUS_OFFER_2025);
                }
            });
        }
        else if (!invitationLoading && offers) {
            // If we've already loaded the offers by way of useInvitation
            screenViewed(useAmpli_1.AmplitudeScreenNames.TS_PLUS_OFFER_2025);
        }
    }, [invitationLoading]);
    if ((isProcessing && !offers) || invitationLoading || (!offers && !error)) {
        return React.createElement(LoadingState_1.default, null);
    }
    if (error) {
        return React.createElement(ErrorMessage_1.default, null);
    }
    return (React.createElement(layouts_1.InvitePageWrapper, null,
        React.createElement(HeaderSection_1.default, null),
        React.createElement("article", { className: "sui-block sui-w-full plus-offer" },
            React.createElement(SubscriptionBenefits_1.default, { benefits: SUBSCRIPTION_BENEFITS }),
            React.createElement(PlanSelection_1.default, { plans: PLANS, selectedPlan: selectedPlan, onPlanSelect: setSelectedPlan }),
            React.createElement(ActionButtons_1.default, { isTrialEligible: isTrialEligible, isProcessing: !!isProcessing, selectedPlan: selectedPlan, onCheckout: onCheckout, onDecline: onDecline }),
            React.createElement("p", { className: "sui-text-center sui-text-gray-50 sui-caption" }, "Cancel anytime. Terms & conditions apply."))));
};
exports.default = TsPlusOfferNew;
